import React, { useState } from 'react';
import Select, { CSSObjectWithLabel, Props } from 'react-select';
import classNames from 'classnames';
import CloseIcon from '@material-ui/icons/Close';

import styles from './SelectWidget.module.scss';

function SelectWidget({ classes, ...props }: SelectWidgetType): JSX.Element {
  const [open, setOpen] = useState<boolean>(false);
  const { className, onMenuClose, onMenuOpen, options, placeholder } = {
    ...props,
  };
  const mobilePlaceholder = {
    label: (
      <>
        <span>{placeholder}</span>
        <CloseIcon
          className={styles.closeIcon}
          onClick={() => setOpen(false)}
        />
      </>
    ),
    value: '',
    isDisabled: true,
  };

  document.body.classList[open ? 'add' : 'remove'](styles.popoverOpened);

  return (
    <Select
      className={classNames(styles.selectContainer, className)}
      classNames={{
        control: () =>
          classNames(styles.control, { [styles.open]: open }, classes?.control),
        option: state => {
          return classNames(styles.option, classes?.option, {
            [styles.selected]: state.isSelected,
            [styles.disabled]: state.isDisabled,
          });
        },
        valueContainer: () =>
          classNames(styles.valueContainer, classes?.valueContainer),
        dropdownIndicator: () =>
          classNames(styles.dropdownIndicator, classes?.dropdownIndicator),
        indicatorSeparator: () => styles.indicatorSeparator,
        menu: () => classNames(styles.menu, classes?.menu),
        menuList: () => classNames(styles.menuList, classes?.menuList),
        singleValue: () => classNames(styles.singleValue, classes?.singleValue),
        menuPortal: () => classNames(styles.menuPortal, classes?.menuPortal),
        placeholder: () => classNames(styles.placeholder, classes?.placeholder),
      }}
      {...(options && { options: [mobilePlaceholder, ...options] })}
      onMenuClose={() => {
        setOpen(false);
        onMenuClose && onMenuClose();
      }}
      onMenuOpen={() => {
        setOpen(true);
        onMenuOpen && onMenuOpen();
      }}
      menuIsOpen={open}
      autoFocus={false}
      isSearchable={false}
      menuPortalTarget={document.body}
      menuShouldScrollIntoView={true}
      styles={{
        dropdownIndicator: (provided, state): CSSObjectWithLabel => ({
          ...provided,
          '& svg': { display: 'none' },
          transform: state.selectProps.menuIsOpen ? 'rotate(90deg)' : undefined,
        }),
      }}
      {...props}
    />
  );
}

export default React.memo(SelectWidget);

type SelectWidgetType = Props & {
  classes?: Partial<SelectFieldCustomClasses>;
};

export type SelectFieldCustomClasses = {
  control?: string;
  dropdownIndicator?: string;
  menu?: string;
  menuList?: string;
  menuPortal?: string;
  option?: string;
  placeholder?: string;
  singleValue?: string;
  valueContainer?: string;
};
